/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import s from './ServicesFooter.scss';

class DistrictDetails extends React.Component {
  render() {
    return (
      <div style={{ display: 'flex' }}>
        {this.props.districts && Object.keys(this.props.districts)
          .filter(urzad => urzad === this.props.prefix)
          .map((urzad, index) => (
            <div className="display-container" key={index}>
              <div style={{ fontWeight: '600' }} className="list-details">{this.props.districts[urzad].name}</div>
              <div className="list-details">
                {this.props.districts[urzad].street}
                {this.props.districts[urzad].nrBuilding.length !== 0
                  ? ` ${this.props.districts[urzad].nrBuilding}`
                  : null}
                {this.props.districts[urzad].nrLocal.length !== 0
                  ? `/${this.props.districts[urzad].nrLocal}`
                  : null}
              </div>
              <div className="list-details">
                {`${this.props.districts[urzad].zipCode} ${this.props.districts[urzad].place}`}
              </div>
              <div className="list-details">
                tel.: {this.props.districts[urzad].phone}
              </div>
              {this.props.districts[urzad].fax && <div className="list-details">
                faks: {this.props.districts[urzad].fax}
              </div>}
              <div className="list-details">{this.props.districts[urzad].email}</div>
              <div className="list-details">
                <a id="deklaracja" href={`/urzad/${this.props.districts[urzad].prefix}/deklaracja-dostepnosci`}>Deklaracja dostępności</a>
              </div>
              <div className="list-details">
                Godziny pracy: {this.props.districts[urzad].workingHours.map(
                    (item, i) => <div key={i}>{item} </div>)
                  }
              </div>
            </div>
          ))}
      </div>
    );
  }
}

const mapState = (state) => ({
  districts: state.district.districts
});

const mapDispatch = {
};

export default withStyles(s)(connect(mapState, mapDispatch)(DistrictDetails));




// WEBPACK FOOTER //
// src/components/ServicesFooter/DistrictDetails.js